import $ from "jquery";

/** Stesso dataset della cardlist mappa_depositi */
var CITIES_JSON_URL = "/application/files/uploads/it-postal-codes-light.json";

var cachedPostalRows = null;
var cachedCityNames = null;

function langPrefix() {
  var raw = document.documentElement.getAttribute("lang") || "it";
  var code = String(raw).toLowerCase().split("-")[0];
  return code.length ? code : "it";
}

function resolveTargetPath(container) {
  var slug =
    container.getAttribute("data-target-slug") || "dove-trovarci";
  slug = String(slug).replace(/^\/+/, "");
  return "/" + langPrefix() + "/" + slug;
}

function performSearch(container, inputEl) {
  if (!container) {
    return;
  }
  var input = inputEl || container.querySelector('input[name="q"]');
  var base = resolveTargetPath(container).split("?")[0];
  var query = input && input.value ? input.value.trim() : "";
  if (query) {
    window.location.href = base + "?q=" + encodeURIComponent(query);
    return;
  }
  window.location.href = base;
}

function escapeHtml(text) {
  return String(text || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

/** Allineato a mappa_depositi.php (NFD + rimozione combining senza regex con backslash) */
function normalizeText(value) {
  var str = String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .trim();
  var out = "";
  for (var i = 0; i < str.length; i++) {
    var code = str.charCodeAt(i);
    if (code >= 0x0300 && code <= 0x036f) {
      continue;
    }
    out += str[i];
  }
  return out;
}

function loadPostalRows() {
  if (cachedPostalRows !== null) {
    return Promise.resolve(cachedPostalRows);
  }
  return fetch(CITIES_JSON_URL, { credentials: "same-origin" })
    .then(function (response) {
      if (!response.ok) {
        throw new Error("Unable to load city dataset");
      }
      return response.json();
    })
    .then(function (payload) {
      cachedPostalRows = Array.isArray(payload && payload.rows) ? payload.rows : [];
      return cachedPostalRows;
    })
    .catch(function () {
      cachedPostalRows = [];
      return cachedPostalRows;
    });
}

function loadCityNames() {
  if (cachedCityNames !== null) {
    return Promise.resolve(cachedCityNames);
  }
  return loadPostalRows()
    .then(function (rows) {
      var unique = {};
      for (var i = 0; i < rows.length; i++) {
        var city = rows[i] && rows[i].city ? String(rows[i].city).trim() : "";
        if (city) {
          unique[city] = true;
        }
      }
      cachedCityNames = Object.keys(unique).sort(function (a, b) {
        return a.localeCompare(b, "it", { sensitivity: "base" });
      });
      return cachedCityNames;
    })
    .catch(function () {
      cachedCityNames = [];
      return cachedCityNames;
    });
}

function populateDatalist(datalistEl, cities) {
  if (!datalistEl) {
    return;
  }
  var html = "";
  for (var i = 0; i < cities.length; i++) {
    html += '<option value="' + escapeHtml(cities[i]) + '"></option>';
  }
  datalistEl.innerHTML = html;
}

/**
 * Comportamento come initCityAutocomplete in mappa_depositi (suggerimenti elenco comuni).
 * Se il valore coincide con un comune (es. scelta dal datalist), invia il form.
 */
function attachCityAutocomplete(inputEl, datalistEl) {
  var container = inputEl.closest(".section-searchbar__form, .section-searchbar__search");

  inputEl.addEventListener("input", function (ev) {
    if (
      container &&
      typeof window.InputEvent !== "undefined" &&
      ev instanceof window.InputEvent &&
      ev.inputType === "insertReplacementText" &&
      inputEl.value.trim()
    ) {
      populateDatalist(datalistEl, []);
      window.requestAnimationFrame(function () {
        performSearch(container, inputEl);
      });
      return;
    }

    var query = inputEl.value || "";
    var normalizedQuery = normalizeText(query);

    if (/[0-9]/.test(normalizedQuery)) {
      populateDatalist(datalistEl, []);
      return;
    }
    if (normalizedQuery.length < 3) {
      populateDatalist(datalistEl, []);
      return;
    }

    loadCityNames().then(function (cityNames) {
      for (var exactIdx = 0; exactIdx < cityNames.length; exactIdx++) {
        if (normalizeText(cityNames[exactIdx]) === normalizedQuery) {
          populateDatalist(datalistEl, []);
          if (container && inputEl.value.trim()) {
            window.requestAnimationFrame(function () {
              performSearch(container, inputEl);
            });
          }
          return;
        }
      }
      var filtered = [];
      for (var i = 0; i < cityNames.length; i++) {
        if (normalizeText(cityNames[i]).indexOf(normalizedQuery) === 0) {
          filtered.push(cityNames[i]);
        }
        if (filtered.length >= 25) {
          break;
        }
      }
      populateDatalist(datalistEl, filtered);
    });
  });

  inputEl.addEventListener("change", function () {
    populateDatalist(datalistEl, []);
  });
}

function uniquifyInstance($form) {
  if ($form.data("sectionSearchbarUid")) {
    return $form.data("sectionSearchbarUid");
  }
  var uid =
    "sb_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 8);
  $form.data("sectionSearchbarUid", uid);

  var headingId = "section-searchbar-heading-" + uid;
  var inputId = "section-searchbar-q-" + uid;

  var $title = $form
    .find(".section-searchbar__heading, .banner-locator-search__title")
    .first();
  if ($title.length) {
    $title.attr("id", headingId);
    $form.attr("aria-labelledby", headingId);
    var $bar = $form.find(".section-searchbar__bar, .cf-search-bar").first();
    if ($bar.length) {
      $bar.attr("aria-labelledby", headingId);
    }
  }

  var $input = $form.find('input[name="q"]').first();
  if ($input.length) {
    $input.attr("id", inputId);
    $form
      .find(
        'label[for="section-searchbar-q"], .section-searchbar__label, .banner-locator-search__label'
      )
      .attr("for", inputId);
  }

  return uid;
}

function initSectionSearchbar(root) {
  var $ctx = root ? $(root) : $(document);
  $ctx.find(".section-searchbar__form, .section-searchbar__search").each(function () {
    var container = this;
    if (container.getAttribute("data-section-searchbar-ready")) {
      return;
    }
    var $container = $(container);
    var uid = uniquifyInstance($container);

    var input = container.querySelector('input[name="q"]');
    if (input && uid) {
      var dl = document.createElement("datalist");
      dl.id = "section-searchbar-dl-" + uid;
      container.appendChild(dl);
      input.setAttribute("list", dl.id);
      attachCityAutocomplete(input, dl);

      input.addEventListener("keydown", function (ev) {
        if (ev.key === "Enter") {
          ev.preventDefault();
          performSearch(container, input);
        }
      });
    }

    $container
      .find(".section-searchbar__submit-icon")
      .off("click.sectionSearchbar")
      .on("click.sectionSearchbar", function (ev) {
        ev.preventDefault();
        performSearch(container, input);
      });

    container.setAttribute("data-section-searchbar-ready", "1");
  });
}

function onGeoClick(ev) {
  var btn = ev.currentTarget;
  var container = btn.closest(".section-searchbar__form, .section-searchbar__search");
  if (!container || !navigator.geolocation) {
    return;
  }
  var base = resolveTargetPath(container).split("?")[0];
  btn.disabled = true;
  navigator.geolocation.getCurrentPosition(
    function (pos) {
      var lat = pos && pos.coords ? pos.coords.latitude : null;
      var lng = pos && pos.coords ? pos.coords.longitude : null;
      if (lat === null || lng === null) {
        btn.disabled = false;
        return;
      }
      window.location.href =
        base +
        "?lat=" +
        encodeURIComponent(lat) +
        "&lng=" +
        encodeURIComponent(lng);
    },
    function () {
      btn.disabled = false;
    },
    {
      enableHighAccuracy: false,
      timeout: 10000,
      maximumAge: 300000,
    }
  );
}

$(document).on("click.sectionSearchbar", ".js-section-searchbar-geo", onGeoClick);

function bindSectionSearchbarLifecycle() {
  initSectionSearchbar(document);
}

$(function () {
  bindSectionSearchbarLifecycle();
});

$(document).ajaxComplete(function () {
  bindSectionSearchbarLifecycle();
});

(function observeLateSectionSearchbar() {
  if (typeof MutationObserver === "undefined") {
    return;
  }
  var t = null;
  var observer = new MutationObserver(function () {
    if (t) {
      clearTimeout(t);
    }
    t = setTimeout(function () {
      t = null;
      if (
        document.querySelector(
          ".section-searchbar__form:not([data-section-searchbar-ready]), .section-searchbar__search:not([data-section-searchbar-ready])",
        )
      ) {
        initSectionSearchbar(document);
      }
    }, 100);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
